/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminTeamsZonesSelector
 */
export interface OutputAdminTeamsZonesSelector {
    /**
     * 
     * @type {Array<number>}
     * @memberof OutputAdminTeamsZonesSelector
     */
    divisions: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminTeamsZonesSelector
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeamsZonesSelector
     */
    name: string;
}

/**
 * Check if a given object implements the OutputAdminTeamsZonesSelector interface.
 */
export function instanceOfOutputAdminTeamsZonesSelector(value: object): boolean {
    if (!('divisions' in value)) return false;
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputAdminTeamsZonesSelectorFromJSON(json: any): OutputAdminTeamsZonesSelector {
    return OutputAdminTeamsZonesSelectorFromJSONTyped(json, false);
}

export function OutputAdminTeamsZonesSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminTeamsZonesSelector {
    if (json == null) {
        return json;
    }
    return {
        
        'divisions': json['divisions'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputAdminTeamsZonesSelectorToJSON(value?: OutputAdminTeamsZonesSelector | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'divisions': value['divisions'],
        'id': value['id'],
        'name': value['name'],
    };
}

